import { render, staticRenderFns } from "./Distractions.vue?vue&type=template&id=89974c22&"
import script from "./Distractions.vue?vue&type=script&lang=js&"
export * from "./Distractions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports